import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getWaterRightsList,
	getWaterRightsListQuery,
	addNewWaterRights,
	updateWaterRights,
	deleteWaterRights,
	getWaterRights,
} from '../waterRights/thunk';

export const initialState = {
	itemWaterRightsList: [],
	itemWaterRightsDetail: null,
	isWaterRightsLoading: false,
	isWaterRightsSuccess: false,

	waterRightsList: [],
	waterRightsListQuery: [],
	waterRightsListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,

	isLoading: false,
	isSuccess: false,
	isError: false,
	error: ""
};

const WaterRightsSlice = createSlice({
	name: 'WaterRights',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getWaterRights.fulfilled, (state, action) => {
			state.isWaterRightsLoading = false;
			state.isWaterRightsSuccess = true;
			state.itemWaterRightsDetail = action.payload;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = true;
		});
		builder.addCase(getWaterRights.pending, state => {
			state.isWaterRightsLoading = true;
			state.isWaterRightsSuccess = null;
			state.error = null;
			state.isLoadingList = true;
			
			state.isLoading = true;
			state.isSuccess = false;
			state.error = null;
		});
		builder.addCase(getWaterRights.rejected, (state, action) => {
			state.isWaterRightsLoading = false;
			state.isWaterRightsSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
			
			state.isLoading = false;
			state.isSuccess = false;
			state.isError = true;
			state.error = action.error.message;
		});

		builder.addCase(getWaterRightsList.pending, state => {
			state.isWaterRightsSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getWaterRightsList.fulfilled, (state, action) => {
			state.itemWaterRightsList = action.payload;
			state.waterRightsList = action.payload;
			state.isLoadingList = false;
			state.isWaterRightsSuccess = true;

			let waterRightsListSelect = [];
			action.payload.map(item =>
				waterRightsListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.waterRightsListSelect = waterRightsListSelect;
		});
		builder.addCase(getWaterRightsList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isWaterRightsSuccess = true;
		});

		builder.addCase(getWaterRightsListQuery.pending, state => {
			state.isLoadingList = true;
		});
		builder.addCase(getWaterRightsListQuery.fulfilled, (state, action) => {
			state.waterRightsListQuery = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getWaterRightsListQuery.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
		});

		builder.addCase(addNewWaterRights.fulfilled, (state, action) => {
			state.itemWaterRightsList.push(action.payload);
			state.waterRightsList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewWaterRights.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewWaterRights.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateWaterRights.fulfilled, (state, action) => {
			state.itemWaterRightsList = state.itemWaterRightsList.map(waterRights =>
				waterRights._id.toString() === action.payload._id.toString()
					? { ...waterRights, ...action.payload }
					: waterRights
			);
			state.waterRightsList = state.waterRightsList.map(waterRights =>
				waterRights._id.toString() === action.payload._id.toString()
					? { ...waterRights, ...action.payload }
					: waterRights
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateWaterRights.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateWaterRights.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteWaterRights.fulfilled, (state, action) => {
			state.itemWaterRightsList = current(state.itemWaterRightsList).filter(
				item => item._id !== action.payload._id
			);
			state.waterRightsList = current(state.waterRightsList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteWaterRights.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteWaterRights.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = WaterRightsSlice.actions;

export default WaterRightsSlice.reducer;
